import { Field } from 'react-final-form';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { composeValidators } from '../utils/validation';
import { jsx as _jsx } from "react/jsx-runtime";
const getMessage = (meta, formControlProps) => {
  if (meta.touched && meta.error) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: `learningCenter.validation.${meta.error}`
    });
  } else {
    if (formControlProps && formControlProps.validationMessage) return formControlProps.validationMessage;
  }
  return null;
};
export const FinalFormField = ({
  render,
  formControlProps,
  fieldProps,
  validators,
  hidden
}) => {
  if (hidden) {
    return null;
  }
  return /*#__PURE__*/_jsx(Field, Object.assign({}, fieldProps, {
    render: ({
      meta,
      input
    }) => /*#__PURE__*/_jsx(FormControl, Object.assign({}, formControlProps, {
      error: !!(meta.touched && meta.error),
      validationMessage: getMessage(meta, formControlProps),
      children: render(input)
    })),
    validate: validators && composeValidators(...validators)
  }));
};